require('./brokerTransferPensionPlansView.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ components
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const AppDownloadWidget = require('components/appDownloadWidget/appDownloadWidget');
const { BrokerInvestmentSpecialist } = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const { ModalUsPersonBlock } = require('components/commons/modalUsPersonBlock/modalUsPersonBlock');

// @ actions
const preContractualMailActions = require('actions/preContractualMailInfo');
const profileActions = require('actions/profile');
// @ constants
const { MYPROFILE_BROKER_URL, BROKER_PG_URL } = require("constants/index");

// @Contact Center constants
const {
    PENSION_PLAN_CONTRIBUTION_PRODUCT_TYPE,
    PENSION_PLAN_TRANSFER_SUB_TYPE,
    PENSION_PLAN_STANDARD
} = require('constants/contactCenter/pensionPlans');

// @utils
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const PersonalDataHelper = require('utilities/personalDataHelper');

/**
* Shows information to the user about Pension Plans
* URL: /myprofile/broker/pensions/transfer/information
*/
class BrokerTransferPensionPlansView extends React.Component {
    constructor(props) {
        super(props);
        this.renderAddress = this.renderAddress.bind(this);
        this.renderPreContractualMailInfo = this.renderPreContractualMailInfo.bind(this);
        this.renderContent = this.renderContent.bind(this);
        this.renderHeader = this.renderHeader.bind(this);
        this.renderSidebar = this.renderSidebar.bind(this);

        //Storing translations here, i don't need to execute the formatText function on every render.
        this.translations = {
            mappingBreadcrumb: [
                {
                    text: formatText('breadcrumb-brokerInvestments'),
                    url: MYPROFILE_BROKER_URL
                },
                {
                    text: formatText('pensionInformation-breadcrumb')
                }
            ],
            walletLinkText: formatText('pensionInformation-walletLinkText'),
            title: formatText('pensionInformation-title'),
            address: formatText('pensionInformation-transferHowToStep1Address'),
            contact: formatText('pensionInformation-transferHowToEmail'),
            transferDocument: formatText('pensionInformation-transferHowToStep1Link'),
            nametag: formatText('pensionInformation-transferHowToStep2Link')
        };
    }

    componentDidMount() {
        scrollToTop();
    }

    componentWillUnmount() {
        __CONTACT_CENTER__ && this.props.resetPrecontractualMail();
    }


    handleGoToMyWalletClick() {
        this.props.history.push(MYPROFILE_BROKER_URL);
    }

    renderAddress() {
        return (
            <address className="pension-plan__list-item__content--address">
                {this.translations.address.split(' / ').map((text, idx) =>
                    (<p key={idx}>
                        {text}
                    </p>)
                )}
            </address>
        );
    }

    renderPreContractualMailInfo() {
        const {
            immProfile,
            immPreContractualMail,
            requestProfile,
            sendPreContractualMail
        } = this.props;
        const refreshEmailAddressError = immProfile.get('error');
        const clientEmailAddress = PersonalDataHelper.getEmail(immProfile);
        const preContractualText = formatText('pensionInformation-preContractualMailText');

        const sendMailParams = {
            standar: PENSION_PLAN_STANDARD,
            type: PENSION_PLAN_CONTRIBUTION_PRODUCT_TYPE,
            subType: PENSION_PLAN_TRANSFER_SUB_TYPE
        };

        return (
            <div className="pension-plan__list-item">
                <span className="precontractual-text">
                    {preContractualText}
                </span>
                <PreContractualMailInfo
                    email={clientEmailAddress}
                    requestProfile={requestProfile}
                    profileError={refreshEmailAddressError}
                    sendEmail={sendPreContractualMail}
                    sendMailParams={sendMailParams}
                    preContractualMail={immPreContractualMail}
                    showLegalText={false}
                />
            </div>
        );
    }

    renderContent() {
        const { immGlobalVariables } = this.props;
        const immContracts = immGlobalVariables.getIn(['variables', 'parameters', 'contratos']);
        const transferPlansURL = immContracts && immContracts.get('transfer_plans')
        return (
            <ContentBox customClassName="" title={this.translations.title} titleSeparator={true}>
                <div className="pension-plan__content-unit">
                    <FormattedText value="pensionInformation-options" />
                </div>
                <div className="pension-plan__content-unit">
                    <h3>
                        <FormattedText value="pensionInformation-entryTransferTitle" />
                    </h3>
                    <FormattedText value="pensionInformation-entryTransferText" />
                </div>
                <div className="pension-plan__content-unit">
                    <h3>
                        <FormattedText value="pensionInformation-internalTransferTitle" />
                    </h3>
                    <FormattedText value="pensionInformation-internalTransferText" />
                </div>
                <div className="pension-plan__content-unit">
                    <h3>
                        <FormattedText value="pensionInformation-transferHowToTitle" />
                    </h3>
                    <div className="pension-plan__list-item">
                        <div className="pension-plan__list-item__bullet">1</div>
                        <div className="pension-plan__list-item__content">
                            <p>
                                <FormattedText value="pensionInformation-transferHowToStep1Part1" />
                                <a
                                    className="pension-plan__link"
                                    target="_blank"
                                    href={transferPlansURL}
                                >
                                    {this.translations.transferDocument}
                                </a>
                                <FormattedText value="pensionInformation-transferHowToStep1Part2" />
                                <a
                                    className="pension-plan__link"
                                    href={`mailto:${this.translations.contact}`}
                                >
                                    {this.translations.contact}
                                </a>
                                <FormattedText value="pensionInformation-transferHowToStep1Part3" />
                            </p>
                            {this.renderAddress()}
                            <p>
                                <FormattedText value="pensionInformation-transferHowToStep1Part4" />
                            </p>
                        </div>
                    </div>
                    {__CONTACT_CENTER__ && this.renderPreContractualMailInfo()}
                    <div className="pension-plan__list-item">
                        <div className="pension-plan__list-item__bullet">2</div>
                        <div className="pension-plan__list-item__content">
                            <p>
                                <FormattedText value="pensionInformation-transferHowToStep2Part1" />
                                <span>
                                    {this.translations.nametag}
                                </span>
                                <FormattedText value="pensionInformation-transferHowToStep2Part2" />
                            </p>
                            <p>
                                <FormattedText value="pensionInformation-transferHowToStep2Part3" />
                                <a
                                    className="pension-plan__link"
                                    href={`mailto:${this.translations.contact}`}
                                >
                                    {this.translations.contact}
                                </a>
                                <FormattedText value="pensionInformation-transferHowToStep2Part4" />
                            </p>
                        </div>
                    </div>
                </div>
                <div className="pension-plan__content-unit">
                    <h3>
                        <FormattedText value="pensionInformation-aboutAXAplansTitle" />
                    </h3>
                    <p>
                        <FormattedText value="pensionInformation-aboutAXAplansDescription" />
                    </p>
                </div>
            </ContentBox>
        );
    }

    renderHeader() {
        return (
            <OKCover size="medium" section="broker">
                <OKHeaderSubPage
                    breadcrumbConfig={this.translations.mappingBreadcrumb}
                    finalTitle={getFinalTitle('pensionInformation-header')}
                >
                    <OKButton
                        inverse={true}
                        modifier="ghost"
                        onClick={() => this.handleGoToMyWalletClick()}
                    >
                        {this.translations.walletLinkText}
                    </OKButton>
                </OKHeaderSubPage>
            </OKCover>
        );
    }

    renderSidebar() {
        return (
            <div className="col-xs-4 pension-plan__sidebar">
                <BrokerInvestmentSpecialist />
                <AppDownloadWidget />
            </div>
        );
    }

    render() {
        const { flagBasedFeatures, history } = this.props;
        const ffUsPersonOpenBrokerageAccount = flagBasedFeatures.get('wealth_pension_plans_bring_to_ok_us_person');
        const content = (
            <article className="pension-plan">
                {this.renderHeader()}
                <section className="pension-plan__body">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-8">
                            {this.renderContent()}
                        </div>
                        {this.renderSidebar()}
                    </div>
                </section>
            </article>
        )
        return (
            <ModalUsPersonBlock
                children={content}
                featureFlag={ffUsPersonOpenBrokerageAccount}
                titleKey={'us_person_popup-pension_plans_bring_to_ok_title'}
                description={'us_person_popup-pension_plans_bring_to_ok_message'}
                buttonClick={() => history.push(BROKER_PG_URL)}
            />
        );
    }
}

BrokerTransferPensionPlansView.propTypes = {
    history: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
};

module.exports.constructor = BrokerTransferPensionPlansView;

module.exports.BrokerTransferPensionPlansView = connect(
    state => ({
        immProfile: state.profile,
        immPreContractualMail: state.preContractualMail,
        immGlobalVariables: state.globalVariables,
        flagBasedFeatures: state.flagBasedFeatures,
    }), {
        requestProfile: profileActions.requestProfile,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
    })(withRouter(BrokerTransferPensionPlansView));
